import { ContactEdit } from '@client/components/contacts/ContactEdit';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import type { ContactType } from '@shared/prisma/enums';
import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { useEffect } from 'react';
import { z } from 'zod';
import { claimFormStore } from '../store';

const ALLOWED_CONTACT_TYPES = [
    'BROKER',
    'DRIVER',
    'INSURER',
    'POLICY_HOLDER',
    'SUPPLIER',
    'THIRD_PARTY',
] as const satisfies ContactType[];

export const Route = createFileRoute('/console/$orgId/claims/details/$id/contacts/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New contact',
        },
    },
    validateSearch: zodValidator(
        z.object({
            type: fallback(z.enum(ALLOWED_CONTACT_TYPES), 'POLICY_HOLDER'),
        }),
    ),
    component: RouteComponent,
});

function RouteComponent() {
    const isReadonly = claimFormStore.use.isReadonly();
    const { id } = Route.useParams();
    const { type } = Route.useSearch();
    const navigate = useNavigate();

    useEffect(() => {
        if (isReadonly) {
            navigate({ moveInMatches: -1 });
        }
    }, [isReadonly]);

    return <ContactEdit action={['add']} type={type} entity="claim" entityId={id} />;
}
